export default "__VITE_ASSET__e51ad35e__"